<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";
  import MenuDropdown from './partial/MenuDropdown.svelte';

  export let block;
</script>

<nav class="navbar navbar-expand-lg navbar-light bg-white" style="margin-bottom: -5em; z-index: 1000">
  <div class="container px-0">
    <a class="navbar-brand font-weight-bold" href="/" rel="tooltip" data-placement="bottom">
      <img src="{image(block, 'logo', [null, null])}" width="200" alt="">
      <!-- <span>{text(block, 'title')}</span> -->
    </a>
    <button class="navbar-toggler shadow-none ms-2" type="button" data-bs-toggle="collapse"
            data-bs-target="#navigation" aria-controls="navigation" aria-expanded="false"
            aria-label="Toggle navigation">
      <span class="navbar-toggler-icon mt-2">
        <span class="navbar-toggler-bar bar1"></span>
        <span class="navbar-toggler-bar bar2"></span>
        <span class="navbar-toggler-bar bar3"></span>
      </span>
    </button>
    <div class="collapse navbar-collapse w-100 pt-3 pb-2 py-lg-0" id="navigation">
      <ul class="navbar-nav navbar-nav-hover mx-auto">
        {#each blocklist(block, 'menu') as item}
        <li class="nav-item mx-2">
          <a href="{url(item, 'button')}" class="fs-6 nav-link ps-2 d-flex justify-content-between cursor-pointer align-items-center" aria-expanded="false" role="button">
            {text(item, 'button')}
          </a>
        </li>
        {/each}
        <li class="nav-item mx-2 pt-1">
          <a href="{url(block, 'sideButton')}" class="btn btn-sm bg-gradient-primary btn-round">{text(block, 'sideButton')}</a>
        </li>
        <!-- <MenuDropdown items={blocklist(block, 'menuAktualu')} name="Aktualu" /> -->
      </ul>
    </div>
  </div>
</nav>
